import { Component, OnInit, Input, ViewChild, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { Auth, Storage } from 'aws-amplify';

@Component({
  selector: 'app-s3-image',
  templateUrl: './s3-image.component.html',
  styleUrls: ['./s3-image.component.scss']
})
export class S3ImageComponent implements OnInit {

  @ViewChild('el') el:ElementRef
  @Input('key') key:string
  src: any;
  constructor() { }

  // Detectar cambios en el valor de key
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.key && !changes.key.firstChange) {
      // Si 'key' cambia, volver a cargar la imagen
      this.getUrl();
    }
  }

  ngOnInit(): void {
    this.getUrl()
  }

  async getUrl(): Promise<void> {
    if (this.key) {
      try {
        const src = await Storage.get(this.key, { customPrefix: { public: '' } });
        this.src = src;
      } catch (error) {
        console.error('Error al obtener la URL de la imagen:', error);
      }
    }
  }

}
